<template>
    <div>
        <div class="clearfix">
            <a-upload 
                v-model:file-list="data.imgList"
                :accept="data.accept"
                :action="data.action"
                :headers="data.headers"
                list-type="picture-card" 
                :before-upload="beforeUpload"
                @preview="handlePreview"
                @change="uploadChange"
                @remove="remove"
            >
                <div v-if="data.imgList.length < 1">
                    <PlusOutlined />
                    <div style="margin-top: 8px">{{ data.title }}</div>
                </div>
            </a-upload>
            <!-- 预览 -->
            <a-modal 
                :visible="previewVisible" 
                :title="previewTitle" 
                :footer="null" 
                @cancel="handleCancel"
            >
                <img alt="example" style="width: 80%" :src="previewImage" />
            </a-modal>
        </div>
    </div>
</template>

<script setup>
    import { ref, defineProps } from 'vue';
    import { PlusOutlined } from '@ant-design/icons-vue';

    const props = defineProps({
        data:{
            type:Object,
            default:()=>{}
        }
    })

    const emit = defineEmits(['uploadChange','uploadRemove'])

    // console.log(props.data,'dddd')
        
    const previewVisible = ref(false)
    const previewImage = ref('')
    const previewTitle = ref('');

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        previewImage.value = file.url || file.preview;
        previewVisible.value = true;
        previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
    };

    const handleCancel = ()=>{
        previewVisible.value = false;
        previewTitle.value = '';
    }

    const beforeUpload = (file) => {
        // console.log(file,'file')
        return false
    };

    const uploadChange = (obj)=>{
        // console.log(obj,'gggg')
        emit('uploadChange',obj.file, obj.fileList)
    }

    const remove = (obj)=>{
        // console.log(obj,'objkk')
        emit('uploadRemove')
    }

    const getBase64 = (file)=> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
</script>

<style lang="scss" scoped></style>